import styled from 'styled-components';
import { GREAT_WHITE, OLAF } from 'HubStyleTokens/colors';
import { TOOLBAR_HEIGHT } from '../../constants/Dimensions';
const DetailHeaderWrapper = styled.div.withConfig({
  displayName: "DetailHeaderWrapper",
  componentId: "sc-1721ps-0"
})(["height:", "px;border-bottom:solid 1px ", ";background-color:", ";z-index:1;flex-shrink:0;"], TOOLBAR_HEIGHT, GREAT_WHITE, OLAF);
export default DetailHeaderWrapper;